import { ErrorHandler } from '@angular/core';
// SA-8637: Sentry loaded from CDN (see src/index.html + src/types/sentry-cdn.d.ts).
var SentryErrorHandler = /** @class */ (function () {
    function SentryErrorHandler() {
    }
    SentryErrorHandler.prototype.handleError = function (error) {
        var extractedError = error.originalError || error.rejection || error;
        // SA-8637: defensive guard — see sentry.utils.ts.
        if (typeof Sentry !== 'undefined') {
            Sentry.captureException(extractedError, {
                tags: {
                    source: 'angular-uncaught'
                }
            });
        }
        // Preserve default Angular logging behaviour
        console.error(error);
    };
    return SentryErrorHandler;
}());
export { SentryErrorHandler };
